<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 2H15C16.1046 2 17 2.89543 17 4V18H16.5H13.5H11.5V2ZM10.5 1H11.5H15C16.6569 1 18 2.34315 18 4V18V19H17V20.5C17 20.7761 16.7761 21 16.5 21H13.5C13.2239 21 13 20.7761 13 20.5V19H11.5H10.5H9V20.5C9 20.7761 8.77614 21 8.5 21H5.5C5.22386 21 5 20.7761 5 20.5V19H4V18V4C4 2.34315 5.34315 1 7 1H10.5ZM6 19V20H8V19H6ZM8.5 18H5.5H5V4C5 2.89543 5.89543 2 7 2H10.5V18H8.5ZM14 19V20H16V19H14ZM13.5 11.5C13.2239 11.5 13 11.2761 13 11V9C13 8.72386 13.2239 8.5 13.5 8.5C13.7761 8.5 14 8.72386 14 9V11C14 11.2761 13.7761 11.5 13.5 11.5ZM8 11C8 11.2761 8.22386 11.5 8.5 11.5C8.77614 11.5 9 11.2761 9 11V9C9 8.72386 8.77614 8.5 8.5 8.5C8.22386 8.5 8 8.72386 8 9V11Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGCase',
};
</script>

<style scoped lang="scss">

</style>
